import axios from 'axios';

export async function sendContactEmail(
	subject: string,
	message: string,
	firstName: string,
	lastName: string,
	phoneNumber: string,
	emailAddress: string,
	recaptchav2: string
) {
	const payload = {
		subject,
		message,
		firstName,
		lastName,
		phoneNumber,
		emailAddress,
		'g-recaptcha-response': recaptchav2,
	};
	return axios.post('/api/contactus', payload, { headers: { 'Content-Type': 'application/json' } }).then(
		async res => res.status,
		err => Promise.reject(err)
	);
}

export const EmailService = {
	sendContactEmail,
};
